import { ModuloValutazioneCompetenza } from ".";

export class ModuloValutazioneDoc {
    id!: string;
    competenze?: Array<ModuloValutazioneCompetenza>;
}